import React, { Component } from "react";
import PropTypes from "prop-types";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Title from "../Title";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { asyncGet, asyncPost } from "../../common/utils";
import { URI_PREFIX, URI } from "../../constants/index";
import {
  PRESCRIPTION,
  OPCONSULTATION_REPORT,
  DISCHARGE_SUMMARY,
  DIAGNOSTIC_REPORT,
  PDF_CONTENT,
  DISCHARGE_SUMMARY1,
} from "../../constants/dataconstants";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import "../../assets/styles/App.css";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import parse from "html-react-parser";
import CircularProgress from "@material-ui/core/CircularProgress";
import { FhirResource, fhirVersions } from "fhir-react";
import "fhir-react/build/style.css";
import "fhir-react/build/bootstrap-reboot.min.css";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";

const styles = (theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    padding: 12,
    overflow: "scroll",
  },
  paper: {
    backgroundColor: "#f2efda", // theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  formControl: {
    minWidth: 170,
  },
});

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const generateElement = (key, value) => {
  return (
    <React.Fragment>
      {value == "heading" ? (
        <TableRow>
          <TableCell style={{ backgroundColor: "#d3d6d6" }}>
            <strong>{key.toUpperCase()}</strong>
          </TableCell>
          <TableCell style={{ backgroundColor: "#d3d6d6" }}></TableCell>
        </TableRow>
      ) : (
        <TableRow>
          <TableCell>
            <strong>
              {capitalizeFirstLetter(key.toUpperCase() == "DIV" ? "" : key)}
            </strong>
          </TableCell>
          <TableCell>
            {value == null || value == "null" ? "N/A" : parse(urlify(value))}
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  );
};

const urlify = (text) => {
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '" target="_blank">' + url + "</a>";
  });
};

// const generateAttachmentElement = (key, value) => {
//     return (
//         <TableRow>
//             <TableCell style={{ backgroundColor: '#d3d6d6' }}><strong>{key.toUpperCase()}</strong></TableCell>
//             <TableCell style={{ backgroundColor: '#d3d6d6' }}><Button variant="contained" color="primary" style={{ marginTop: '5px' }} onClick={() => onShowPdf(value)}>View</Button></TableCell>
//         </TableRow>
//     );
// }

// function generateData(data) {
//     const newData = Object.keys(data).reduce((result, currentKey, index) => {//debugger;
//         if (typeof data[currentKey] === 'string' || data[currentKey] instanceof String) {
//             const elementToPush = isNaN(currentKey) ? generateElement(currentKey, data[currentKey]) : generateElement("Link", data[currentKey]);
//             result.push(elementToPush);
//         } else {
//             if (currentKey == "attachment") {//debugger
//                 let attachment = data[currentKey];
//                 const elementToPush = generateAttachmentElement(attachment.title, attachment.data);
//                 result.push(elementToPush);
//             } else {
//                 if (isNaN(currentKey)) {
//                     if (data[currentKey] && data[currentKey].length > 0) {
//                         const elementToPush = generateElement(currentKey, "heading");
//                         result.push(elementToPush);
//                     }
//                     const nested = generateData(data[currentKey]);
//                     result.push(...nested);
//                 } else {
//                     const nested = generateData(data[currentKey]);
//                     result.push(...nested);
//                 }
//             }
//         }
//         return result;
//     }, []);
//     return newData;
// }

const defaultState = {
  reportType: null,
  report: [],
  excludeResources: ["Practitioner", "Composition"],
  showPdf: false,
  pageNumber: 1,
  pdfContent: "",
  currReportIndex: 0,
  reportName: "",
  imageData: null,
};
class Viewer extends Component {
  constructor(props) {
    super(props);
    this.state = JSON.parse(JSON.stringify(defaultState));
  }

  showImage = (value) => {
    //debugger;
    this.setState({ imageData: value, isModalOpen: true });
  };

  onShowPdf = (value) => {
    //debugger;
    // this.setState({ showPdf: true, pdfContent:PDF_CONTENT })
    // var base64 = btoa(
    //     new Uint8Array(value)
    //       .reduce((data, byte) => data + String.fromCharCode(byte), '')
    //   );

    var windo = window.open("", "");
    var objbuilder = "";
    objbuilder +=
      "<embed width='100%' height='100%'  src=\"data:application/pdf;base64,";
    objbuilder += value;
    objbuilder += '" type="application/pdf" />';
    windo.document.write(objbuilder);
  };

  populateReport = (data, repoIndex) => {
    debugger;
    let arr = [];
    let identificationNo = "";
    let totalEntries = data.length;
    if (repoIndex >= data.length) {
      return <div>No more record found</div>;
    }
    if (data && data.length > 0) {
      // arr = data[0].entry ? data[0].entry : data[0].entries[repoIndex].data.entry;
      identificationNo = data[repoIndex].id ? data[repoIndex].id : "";
      arr = data[repoIndex].entry;
    }
    return (
      <div>
        {arr.map((item) => {
          let arrLst = this.state.excludeResources.filter(
            (e) => e.toUpperCase() == item.resource.resourceType.toUpperCase()
          );
          if (item.resource.resourceType == "Patient") {
            if (item.resource.name && item.resource.name.length > 0) {
              let objGiven = null;
              if (item.resource.name[0].hasOwnProperty("text")) {
                let given = [];
                given.push(item.resource.name[0].text);
                objGiven = { given: given };
              }
              delete item.resource.name[0].text;
              item.resource.name.push(objGiven);
            }
          }
          if (arrLst && arrLst.length == 0) {
            if (
              item.resource["documentReference"]
                ? item.resource["documentReference"]
                : item.resource.resourceType == "DocumentReference"
            ) {
              debugger;
              return (
                <div style={{ padding: 10, backgroundColor: "#ffffff" }}>
                  <div style={{ paddingBottom: 20, marginLeft: 20 }}>
                    <div>
                      <h5>
                        <strong>ENCLOSED CLINICAL DOCUMENTS</strong>
                      </h5>
                    </div>
                    <div>
                      <strong>Status:</strong>{" "}
                      {item.resource.status ? item.resource.status : ""}{" "}
                    </div>
                    <div>
                      <strong>Identification No:</strong> {identificationNo}{" "}
                    </div>
                    <div>
                      {item.resource.content &&
                        item.resource.content.length > 0 &&
                        item.resource.content.map((item) => {
                          if (item.attachment) {
                            if (
                              item.attachment.contentType == "application/pdf"
                            ) {
                              return (
                                <div style={{ float: "left" }}>
                                  <a
                                    href="javascript:void(0)"
                                    onClick={() =>
                                      this.onShowPdf(item.attachment.data)
                                    }
                                  >
                                    {item.attachment.title}
                                  </a>
                                </div>
                              );
                            } else {
                              return (
                                <a
                                  href="javascript:void(0);"
                                  onClick={() =>
                                    this.showImage(
                                      "data:image/png;base64," +
                                        item.attachment.data
                                    )
                                  }
                                >
                                  View {item.attachment.title}
                                </a>
                              );
                            }
                          } else {
                            if (item.contentType == "application/pdf") {
                              return (
                                <div style={{ float: "left" }}>
                                  <a
                                    href="javascript:void(0)"
                                    onClick={() => this.onShowPdf(item.data)}
                                  >
                                    {item.title}
                                  </a>
                                </div>
                              );
                            } else {
                              return (
                                <a
                                  href="javascript:void(0);"
                                  onClick={() =>
                                    this.showImage(
                                      "data:image/png;base64," + item.data
                                    )
                                  }
                                >
                                  View {item.title}
                                </a>
                              );
                            }
                          }
                        })}
                    </div>
                    <br />
                    <div>
                      {" "}
                      Showing {repoIndex + 1} of {totalEntries} records
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div style={{ backgroundColor: "#ffffff" }}>
                  <FhirResource
                    fhirResource={item.resource}
                    fhirVersion={fhirVersions.R4}
                    withCarinBBProfile
                  />

                  {item.resource.presentedForm &&
                    item.resource.presentedForm.length > 0 && (
                      <div
                        style={{
                          padding: 10,
                          marginLeft: 20,
                          backgroundColor: "#ffffff",
                        }}
                      >
                        <div>
                          <h6>
                            <strong>ENCLOSED REPORTS</strong>
                          </h6>
                        </div>
                        <div>
                          {item.resource.presentedForm.map((item, index) => {
                            if (item.contentType == "image/jpeg") {
                              return (
                                <a
                                  href="javascript:void(0);"
                                  onClick={() =>
                                    this.showImage(
                                      "data:image/png;base64," + item.data
                                    )
                                  }
                                >
                                  Report
                                </a>
                              );
                            }
                          })}
                        </div>
                      </div>
                    )}
                </div>
              );
            }
          }
        })}
      </div>
    );
  };

  componentDidMount() {
    this.setState({ showLoader: true });
    // setTimeout(() => {
    //     this.fetchConsentArtefacts();
    // }, 6000);
    this.fetchConsentArtefacts();
  }
  //To get the Consent Artefact of the Respective User
  fetchConsentArtefacts = async () => {
    // debugger;
    const url =
      URI.getConsentArtefacts + "?consentReqId=" + global.consentReqId;
    const res = await asyncGet(url, true, global.token, true, false);
    if (res && res.status == 2000) {
      // debugger
      let arr = [];
      if (res.data && res.data.length > 0) {
        // debugger;
        res.data.map((item) => {
          let arrDecoded = JSON.parse(item.decodedValue);
          if (arrDecoded) {
            console.log("json : " + item.decodedValue);
            arr.push(JSON.parse(item.decodedValue));
            // if (arrDecoded.length > 0)
            //     arr.push(JSON.parse(item.decodedValue)[0]);
            // else
            //     arr.push(JSON.parse(item.decodedValue));
          }
        });
      }
      console.log("size of arr :" + arr.length);
      // debugger
      this.setState({ showLoader: false, report: arr });
    } else {
      this.setState({ showLoader: false });
      alert("Unable to find record.");
    }
  };

  handleModalClose = () => {
    this.setState({ showPdf: false });
  };

  handlePrevious = () => {
    let currIndex = this.state.currReportIndex;
    if (currIndex > 0) {
      currIndex = currIndex - 1;
      this.setState({ currReportIndex: currIndex });
    }
  };

  handleNext = () => {
    let currIndex = this.state.currReportIndex;
    if (currIndex < this.state.report.length) {
      currIndex = currIndex + 1;
      this.setState({ currReportIndex: currIndex });
    }
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false, modalFor: "", imageData: null });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Paper className={classes.paper} style={{ padding: "10px" }}>
          <div style={{ float: "right" }}>
            <a
              href="javascript:history.go(-1)"
              style={{ textDecoration: "none", color: global.secondaryColour }}
            >
              Back
            </a>
          </div>
          <Grid container direction={"row"} spacing={5}>
            {!this.state.showLoader ? (
              <Table size="small" style={{ margin: "30px" }}>
                <TableBody style={{ textAlign: "left" }}>
                  <Box justifyContent="center" display="flex">
                    <Button type="button" onClick={() => this.handlePrevious()}>
                      <KeyboardArrowLeftIcon />
                    </Button>
                    <div style={{ marginTop: 8 }}>{this.state.reportName}</div>
                    <Button type="button" onClick={() => this.handleNext()}>
                      <KeyboardArrowRightIcon />
                    </Button>
                  </Box>
                  {this.state.report && this.state.report.length > 0
                    ? this.populateReport(
                        this.state.report,
                        this.state.currReportIndex
                      )
                    : "No data found."}
                </TableBody>
              </Table>
            ) : (
              <div
                style={{ textAlign: "center", marginTop: 10, marginLeft: 500 }}
              >
                <CircularProgress />
                <h5 style={{ marginTop: 5 }}>Loading...</h5>
              </div>
            )}
          </Grid>
        </Paper>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={this.state.isModalOpen}
          onClose={() => this.handleModalClose()}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={this.state.isModalOpen}>
            <div style={{ padding: 10, backgroundColor: "#ffffff" }}>
              <div style={{ alignContent: "center" }}>
                <h6>
                  <strong>VIEW REPORT</strong>
                </h6>
              </div>
              <img src={this.state.imageData} />
              <div style={{ alignContent: "center" }}>
                <Button type="button" onClick={() => this.handleModalClose()}>
                  <CloseIcon />
                </Button>
              </div>
            </div>
          </Fade>
        </Modal>
      </React.Fragment>
    );
  }
}

Viewer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Viewer);
